import css from "./main.module.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { useEffect, useState, useRef } from "react";
import { trackDemoStarted, trackOnboardingStart, trackTrialStarted } from "../../lib/analytics";

const FirstBlock = ({ authUser }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const hasInteractedRef = useRef(false);
  const autoScrollTimeoutRef = useRef(null);

  const markAsInteracted = () => {
    hasInteractedRef.current = true;
    sessionStorage.setItem("userHasInteracted", "true");
  };

  const handleNavigation = (path) => {
    markAsInteracted();
    navigate(path);
  };

  // Handle user scroll and other interactions
  useEffect(() => {
    const handleInteraction = () => {
      markAsInteracted();
    };

    // Listen for various user interactions
    window.addEventListener('scroll', handleInteraction, { passive: true });
    window.addEventListener('click', handleInteraction);
    window.addEventListener('keydown', handleInteraction);
    window.addEventListener('touchstart', handleInteraction);

    // Clear any existing interaction state when component mounts
    if (!sessionStorage.getItem("fromOnboarding")) {
      sessionStorage.removeItem("userHasInteracted");
    }

    return () => {
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('click', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);


  useEffect(() => {
    // Trigger animations after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  const getTitleText = () => {
    const heroTitles = {
      en: {
        firstLine: "MASTER",
        secondLine: "ENGLISH",
        thirdLine: "THROUGH VIDEOS"
      },
      uk: {
        firstLine: "МЕНШЕ",
        secondLine: "ПРАВИЛ,",
        thirdLine: "БІЛЬШЕ РОЗМОВ"
      },
      pl: {
        firstLine: "MNIEJ",
        secondLine: "ZASAD,",
        thirdLine: "WIĘCEJ ROZMÓW"
      }
    };

    const currentLang = i18n.language || 'en';
    return heroTitles[currentLang] || heroTitles.en;
  };

  const titleData = getTitleText();

  return (
    <main className={css.mainContent}>
      <h1 className={`${css.heroTitle} ${isVisible ? css.reveal : ''}`}>
        {titleData.firstLine} <span className={css.highlightEnglish}>{titleData.secondLine}</span><br />
        {titleData.thirdLine}
      </h1>

      <p className={`${css.subtitle} ${isVisible ? css.reveal : ''}`}>
        {t("Start speaking with confidence from day one")}
      </p>

      <div className={`${css.ctaButtons} ${isVisible ? css.reveal : ''}`}>
        <button
          className={`${css.ctaBtn} ${css.startLearningBtn}`}
          onClick={() => {
            trackOnboardingStart();
            trackTrialStarted();
            handleNavigation("/survey");
          }}
          data-hero-btn
        >
          {t("Start Learning Free")} →
        </button>
        <button
          className={`${css.ctaBtn} ${css.tryDemoBtn}`}
          onClick={() => {
            trackDemoStarted();
            handleNavigation("/lesson/774");
          }}
        >
          {t("TRY 2-MIN DEMO")}
        </button>
      </div>

      <div className={`${css.whyChoose} ${isVisible ? css.reveal : ''}`}>
        <h2>{t("WHY CHOOSE AI LINGUA?")}</h2>
        <div className={css.features}>
          <div className={css.featureCard}>
            <div className={css.featureIcon}>🎬</div>
            <h3>{t("REAL-LIFE VIDEOS")}</h3>
          </div>
          <div className={css.featureCard}>
            <div className={css.featureIcon}>🤖</div>
            <h3>{t("AI-POWERED PRACTICE")}</h3>
          </div>
          <div className={css.featureCard}>
            <div className={css.featureIcon}>📈</div>
            <h3>{t("ALL LEVELS WELCOME")}</h3>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FirstBlock;
